<template>
  <div>
    <payment-gateway
      :toolbar="false"
      :paypal="false"
      :compact="true"
      ref="paymentGateway"
      @card="listenCard"
      @card-switch="listenCardNew"
    ></payment-gateway>
  </div>
</template>

<script>
import PaymentGateway from '@/components/Common/PaymentGateway'

export default {
  name: 'CertificatePayment',
  components: {
    PaymentGateway
  },
  data () {
    return {
      isNewCard: false,
      card: {
        cardnum: '',
        cardnum_cvv: '',
        expdate: ''
      }
    }
  },
  methods: {
    listenCard (card) {
      this.card = card
    },
    listenCardNew (isNew) {
      this.isNewCard = isNew
    },
    async validateCard () {
      const valid = await this.$refs.paymentGateway.validateForm()
      return valid
    },
    cardData () {
      if (this.isNewCard) {
        return this.card
      }
      return {
        cardnum_cvv: this.card.cardnum_cvv
      }
    },
  }
}
</script>
